/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * XConvert API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as url from "url";
import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://localhost:9800/ftp".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *  
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 * 
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 * 
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError" = "RequiredError";
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AddFileRequest
 */
export interface AddFileRequest {
    /**
     * 
     * @type {string}
     * @memberof AddFileRequest
     */
    base64Content?: string;
    /**
     * 
     * @type {string}
     * @memberof AddFileRequest
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof AddFileRequest
     */
    encoding?: string;
    /**
     * 
     * @type {string}
     * @memberof AddFileRequest
     */
    fileName?: string;
}

/**
 * 
 * @export
 * @interface AddFilesRequest
 */
export interface AddFilesRequest {
    /**
     * 
     * @type {Array<AddFileRequest>}
     * @memberof AddFilesRequest
     */
    files?: Array<AddFileRequest>;
}

/**
 * 
 * @export
 * @interface AddFilesResponse
 */
export interface AddFilesResponse {
    /**
     * 
     * @type {string}
     * @memberof AddFilesResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddFilesResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface CreateDownloadSignatureResponse
 */
export interface CreateDownloadSignatureResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateDownloadSignatureResponse
     */
    companyId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateDownloadSignatureResponse
     */
    expiresAt?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDownloadSignatureResponse
     */
    filePath?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDownloadSignatureResponse
     */
    signedUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDownloadSignatureResponse
     */
    zipCreated?: boolean;
}

/**
 * 
 * @export
 * @interface CreateZipResponse
 */
export interface CreateZipResponse {
    /**
     * 
     * @type {FileSystemEntry}
     * @memberof CreateZipResponse
     */
    file?: FileSystemEntry;
    /**
     * 
     * @type {boolean}
     * @memberof CreateZipResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface DeleteFileResponse
 */
export interface DeleteFileResponse {
    /**
     * 
     * @type {string}
     * @memberof DeleteFileResponse
     */
    deletedPath?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteFileResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DeleteFileResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface DisabledChecksForCompanyReport
 */
export interface DisabledChecksForCompanyReport {
    /**
     * 
     * @type {boolean}
     * @memberof DisabledChecksForCompanyReport
     */
    apiGatewayMonitoring?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledChecksForCompanyReport
     */
    apiSyncQueueMonitoring?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DisabledChecksForCompanyReport
     */
    companyId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledChecksForCompanyReport
     */
    errorFilesMonitoring?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledChecksForCompanyReport
     */
    logenios2CustomerMonitoring?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledChecksForCompanyReport
     */
    queuedEventsErrorMonitoring?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledChecksForCompanyReport
     */
    sftpSyncMonitoring?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledChecksForCompanyReport
     */
    statusJsonMonitoring?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledChecksForCompanyReport
     */
    vehicleAssignmentMonitoring?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledChecksForCompanyReport
     */
    vehiclePositionsMonitoring?: boolean;
}

/**
 * 
 * @export
 * @interface DownloadFilesAsZipRequest
 */
export interface DownloadFilesAsZipRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DownloadFilesAsZipRequest
     */
    fileNames?: Array<string>;
}

/**
 * 
 * @export
 * @interface ErrorsFilesCountCompany
 */
export interface ErrorsFilesCountCompany {
    /**
     * 
     * @type {string}
     * @memberof ErrorsFilesCountCompany
     */
    acknowledgingPm?: string;
    /**
     * 
     * @type {Date}
     * @memberof ErrorsFilesCountCompany
     */
    acknowledgingTimeStamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof ErrorsFilesCountCompany
     */
    companyId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ErrorsFilesCountCompany
     */
    disableTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof ErrorsFilesCountCompany
     */
    disableType?: ErrorsFilesCountCompany.DisableTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ErrorsFilesCountCompany
     */
    disableUntil?: Date;
    /**
     * 
     * @type {number}
     * @memberof ErrorsFilesCountCompany
     */
    filesOlderThanFiveMinutes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ErrorsFilesCountCompany
     */
    isAcknowledgedByPm?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ErrorsFilesCountCompany
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ErrorsFilesCountCompany
     */
    oldestFileInMinutes?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorsFilesCountCompany
     */
    personWhoIgnored?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorsFilesCountCompany
     */
    reasonToIgnore?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorsFilesCountCompany
     */
    responsibleManager?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ErrorsFilesCountCompany
     */
    shouldBeIgnored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ErrorsFilesCountCompany
     */
    tag?: string;
    /**
     * 
     * @type {number}
     * @memberof ErrorsFilesCountCompany
     */
    youngestFileInMinutes?: number;
}

/**
 * @export
 * @namespace ErrorsFilesCountCompany
 */
export namespace ErrorsFilesCountCompany {
    /**
     * @export
     * @enum {string}
     */
    export enum DisableTypeEnum {
        UNTILCHANGE = 'UNTIL_CHANGE',
        UNTILTOMORROW = 'UNTIL_TOMORROW',
        FORAMONTH = 'FOR_A_MONTH',
        FORAWEEK = 'FOR_A_WEEK',
        CUSTOMDATE = 'CUSTOM_DATE'
    }
}

/**
 * 
 * @export
 * @interface FileHashResponse
 */
export interface FileHashResponse {
    /**
     * 
     * @type {string}
     * @memberof FileHashResponse
     */
    file?: string;
    /**
     * 
     * @type {string}
     * @memberof FileHashResponse
     */
    md5Hash?: string;
}

/**
 * 
 * @export
 * @interface FileSystemEntry
 */
export interface FileSystemEntry {
    /**
     * 
     * @type {Date}
     * @memberof FileSystemEntry
     */
    created?: Date;
    /**
     * 
     * @type {string}
     * @memberof FileSystemEntry
     */
    fileKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FileSystemEntry
     */
    isDirectory?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FileSystemEntry
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof FileSystemEntry
     */
    size?: number;
    /**
     * 
     * @type {Date}
     * @memberof FileSystemEntry
     */
    updated?: Date;
}

/**
 * 
 * @export
 * @interface GetConvertingFilesCount
 */
export interface GetConvertingFilesCount {
}

/**
 * 
 * @export
 * @interface GetErrorFilesCountResponse
 */
export interface GetErrorFilesCountResponse {
    /**
     * 
     * @type {Array<ErrorsFilesCountCompany>}
     * @memberof GetErrorFilesCountResponse
     */
    companies?: Array<ErrorsFilesCountCompany>;
    /**
     * 
     * @type {number}
     * @memberof GetErrorFilesCountResponse
     */
    filesOlderThanFiveMinutes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetErrorFilesCountResponse
     */
    healthy?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetErrorFilesCountResponse
     */
    output?: string;
}

/**
 * 
 * @export
 * @interface GetNeedsVerificationFilesCountResponse
 */
export interface GetNeedsVerificationFilesCountResponse {
    /**
     * 
     * @type {Array<NeedsVerificationFilesCountCompany>}
     * @memberof GetNeedsVerificationFilesCountResponse
     */
    companies?: Array<NeedsVerificationFilesCountCompany>;
    /**
     * 
     * @type {number}
     * @memberof GetNeedsVerificationFilesCountResponse
     */
    filesOlderThanFiveMinutes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetNeedsVerificationFilesCountResponse
     */
    healthy?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetNeedsVerificationFilesCountResponse
     */
    output?: string;
}

/**
 * Arbitrary key value pairs
 * @export
 * @interface HashMap
 */
export interface HashMap {
}

/**
 * 
 * @export
 * @interface ListFilesResponse
 */
export interface ListFilesResponse {
    /**
     * 
     * @type {Array<FileSystemEntry>}
     * @memberof ListFilesResponse
     */
    files?: Array<FileSystemEntry>;
    /**
     * 
     * @type {number}
     * @memberof ListFilesResponse
     */
    page?: number;
    /**
     * 
     * @type {string}
     * @memberof ListFilesResponse
     */
    path?: string;
    /**
     * 
     * @type {number}
     * @memberof ListFilesResponse
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof ListFilesResponse
     */
    totalFiles?: number;
}

/**
 * 
 * @export
 * @interface MonitoredFileOldResponse
 */
export interface MonitoredFileOldResponse {
    /**
     * 
     * @type {string}
     * @memberof MonitoredFileOldResponse
     */
    companyId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitoredFileOldResponse
     */
    files?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof MonitoredFileOldResponse
     */
    old?: boolean;
}

/**
 * 
 * @export
 * @interface MoveFileRequest
 */
export interface MoveFileRequest {
    /**
     * 
     * @type {boolean}
     * @memberof MoveFileRequest
     */
    copy?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveFileRequest
     */
    fileNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveFileRequest
     */
    targetFileNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MoveFileRequest
     */
    targetPath?: string;
}

/**
 * 
 * @export
 * @interface MoveFileResponse
 */
export interface MoveFileResponse {
    /**
     * 
     * @type {string}
     * @memberof MoveFileResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof MoveFileResponse
     */
    newPath?: string;
    /**
     * 
     * @type {string}
     * @memberof MoveFileResponse
     */
    oldPath?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MoveFileResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface NeedsVerificationFilesCountCompany
 */
export interface NeedsVerificationFilesCountCompany {
    /**
     * 
     * @type {string}
     * @memberof NeedsVerificationFilesCountCompany
     */
    acknowledgingPm?: string;
    /**
     * 
     * @type {Date}
     * @memberof NeedsVerificationFilesCountCompany
     */
    acknowledgingTimeStamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof NeedsVerificationFilesCountCompany
     */
    companyId?: string;
    /**
     * 
     * @type {Date}
     * @memberof NeedsVerificationFilesCountCompany
     */
    disableTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof NeedsVerificationFilesCountCompany
     */
    disableType?: NeedsVerificationFilesCountCompany.DisableTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof NeedsVerificationFilesCountCompany
     */
    disableUntil?: Date;
    /**
     * 
     * @type {number}
     * @memberof NeedsVerificationFilesCountCompany
     */
    filesOlderThanFiveMinutes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NeedsVerificationFilesCountCompany
     */
    isAcknowledgedByPm?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NeedsVerificationFilesCountCompany
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof NeedsVerificationFilesCountCompany
     */
    oldestFileInMinutes?: number;
    /**
     * 
     * @type {string}
     * @memberof NeedsVerificationFilesCountCompany
     */
    personWhoIgnored?: string;
    /**
     * 
     * @type {string}
     * @memberof NeedsVerificationFilesCountCompany
     */
    reasonToIgnore?: string;
    /**
     * 
     * @type {string}
     * @memberof NeedsVerificationFilesCountCompany
     */
    responsibleManager?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NeedsVerificationFilesCountCompany
     */
    shouldBeIgnored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NeedsVerificationFilesCountCompany
     */
    tag?: string;
}

/**
 * @export
 * @namespace NeedsVerificationFilesCountCompany
 */
export namespace NeedsVerificationFilesCountCompany {
    /**
     * @export
     * @enum {string}
     */
    export enum DisableTypeEnum {
        UNTILCHANGE = 'UNTIL_CHANGE',
        UNTILTOMORROW = 'UNTIL_TOMORROW',
        FORAMONTH = 'FOR_A_MONTH',
        FORAWEEK = 'FOR_A_WEEK',
        CUSTOMDATE = 'CUSTOM_DATE'
    }
}

/**
 * 
 * @export
 * @interface OpenFileRequest
 */
export interface OpenFileRequest {
    /**
     * 
     * @type {string}
     * @memberof OpenFileRequest
     */
    fileName?: string;
}

/**
 * 
 * @export
 * @interface RenameFileRequest
 */
export interface RenameFileRequest {
    /**
     * 
     * @type {string}
     * @memberof RenameFileRequest
     */
    newName?: string;
    /**
     * 
     * @type {string}
     * @memberof RenameFileRequest
     */
    oldName?: string;
}

/**
 * 
 * @export
 * @interface RenameFileResponse
 */
export interface RenameFileResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RenameFileResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface StatusJsonReport
 */
export interface StatusJsonReport {
    /**
     * 
     * @type {Array<StatusJsonReportCompany>}
     * @memberof StatusJsonReport
     */
    companies?: Array<StatusJsonReportCompany>;
    /**
     * 
     * @type {number}
     * @memberof StatusJsonReport
     */
    companiesMissingStatusJsonFile?: number;
    /**
     * 
     * @type {number}
     * @memberof StatusJsonReport
     */
    companiesWithLastRunOld?: number;
    /**
     * 
     * @type {number}
     * @memberof StatusJsonReport
     */
    companiesWithoutRecentFileUpdate?: number;
    /**
     * 
     * @type {number}
     * @memberof StatusJsonReport
     */
    totalCompaniesChecked?: number;
    /**
     * 
     * @type {number}
     * @memberof StatusJsonReport
     */
    unhealthyCompanies?: number;
}

/**
 * 
 * @export
 * @interface StatusJsonReportCompany
 */
export interface StatusJsonReportCompany {
    /**
     * 
     * @type {string}
     * @memberof StatusJsonReportCompany
     */
    acknowledgingPm?: string;
    /**
     * 
     * @type {Date}
     * @memberof StatusJsonReportCompany
     */
    acknowledgingTimeStamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof StatusJsonReportCompany
     */
    checkMode?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusJsonReportCompany
     */
    companyId?: string;
    /**
     * 
     * @type {Date}
     * @memberof StatusJsonReportCompany
     */
    disableTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof StatusJsonReportCompany
     */
    disableType?: StatusJsonReportCompany.DisableTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof StatusJsonReportCompany
     */
    disableUntil?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof StatusJsonReportCompany
     */
    healthy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatusJsonReportCompany
     */
    isAcknowledgedByPm?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof StatusJsonReportCompany
     */
    lastFileUpdate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof StatusJsonReportCompany
     */
    lastFileUpdateTooOld?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof StatusJsonReportCompany
     */
    lastRun?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof StatusJsonReportCompany
     */
    lastRunTooOld?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StatusJsonReportCompany
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusJsonReportCompany
     */
    otherError?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusJsonReportCompany
     */
    personWhoIgnored?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusJsonReportCompany
     */
    reasonToIgnore?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusJsonReportCompany
     */
    responsibleManager?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StatusJsonReportCompany
     */
    shouldBeIgnored?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatusJsonReportCompany
     */
    statusJsonExists?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StatusJsonReportCompany
     */
    statusLine?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusJsonReportCompany
     */
    tag?: string;
}

/**
 * @export
 * @namespace StatusJsonReportCompany
 */
export namespace StatusJsonReportCompany {
    /**
     * @export
     * @enum {string}
     */
    export enum DisableTypeEnum {
        UNTILCHANGE = 'UNTIL_CHANGE',
        UNTILTOMORROW = 'UNTIL_TOMORROW',
        FORAMONTH = 'FOR_A_MONTH',
        FORAWEEK = 'FOR_A_WEEK',
        CUSTOMDATE = 'CUSTOM_DATE'
    }
}

/**
 * 
 * @export
 * @interface UploadFileResponse
 */
export interface UploadFileResponse {
    /**
     * 
     * @type {string}
     * @memberof UploadFileResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadFileResponse
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadFileResponse
     */
    newPath?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UploadFileResponse
     */
    success?: boolean;
}


/**
 * FTPApi - fetch parameter creator
 * @export
 */
export const FTPApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add text as file to a given location.
         * @summary Add file
         * @param {string} path path
         * @param {AddFileRequest} AddFileRequest AddFileRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFile(path: string, AddFileRequest: AddFileRequest, companyId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'path' is not null or undefined
            if (path === null || path === undefined) {
                throw new RequiredError('path','Required parameter path was null or undefined when calling addFile.');
            }
            // verify required parameter 'AddFileRequest' is not null or undefined
            if (AddFileRequest === null || AddFileRequest === undefined) {
                throw new RequiredError('AddFileRequest','Required parameter AddFileRequest was null or undefined when calling addFile.');
            }
            const localVarPath = `/files/add`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AddFileRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AddFileRequest || {}) : (AddFileRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add text as file to a given location.
         * @summary Add files
         * @param {string} path path
         * @param {AddFilesRequest} AddFilesRequest AddFilesRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFiles(path: string, AddFilesRequest: AddFilesRequest, companyId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'path' is not null or undefined
            if (path === null || path === undefined) {
                throw new RequiredError('path','Required parameter path was null or undefined when calling addFiles.');
            }
            // verify required parameter 'AddFilesRequest' is not null or undefined
            if (AddFilesRequest === null || AddFilesRequest === undefined) {
                throw new RequiredError('AddFilesRequest','Required parameter AddFilesRequest was null or undefined when calling addFiles.');
            }
            const localVarPath = `/files/addMultipleFiles`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AddFilesRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AddFilesRequest || {}) : (AddFilesRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * gives back the content of a file
         * @summary opens a file
         * @param {string} file file
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateFileHashFromRoot(file: string, companyId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling calculateFileHashFromRoot.');
            }
            const localVarPath = `/file-hash/{file}`
                .replace(`{${"file"}}`, encodeURIComponent(String(file)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move a file to another location.
         * @summary create directory
         * @param {string} path path
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDirectory(path: string, companyId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'path' is not null or undefined
            if (path === null || path === undefined) {
                throw new RequiredError('path','Required parameter path was null or undefined when calling createDirectory.');
            }
            const localVarPath = `/files/createDirectory`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * creates a one time signature to download a file
         * @summary creates a one time signature to download a file
         * @param {string} fileName fileName
         * @param {string} filePath filePath
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDownloadSignature(fileName: string, filePath: string, companyId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling createDownloadSignature.');
            }
            // verify required parameter 'filePath' is not null or undefined
            if (filePath === null || filePath === undefined) {
                throw new RequiredError('filePath','Required parameter filePath was null or undefined when calling createDownloadSignature.');
            }
            const localVarPath = `/files/createDownloadSignature/{filePath}/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)))
                .replace(`{${"filePath"}}`, encodeURIComponent(String(filePath)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * packs files as zip
         * @summary packs files as zip
         * @param {string} path path
         * @param {DownloadFilesAsZipRequest} DownloadFilesAsZipRequest DownloadFilesAsZipRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createZip(path: string, DownloadFilesAsZipRequest: DownloadFilesAsZipRequest, companyId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'path' is not null or undefined
            if (path === null || path === undefined) {
                throw new RequiredError('path','Required parameter path was null or undefined when calling createZip.');
            }
            // verify required parameter 'DownloadFilesAsZipRequest' is not null or undefined
            if (DownloadFilesAsZipRequest === null || DownloadFilesAsZipRequest === undefined) {
                throw new RequiredError('DownloadFilesAsZipRequest','Required parameter DownloadFilesAsZipRequest was null or undefined when calling createZip.');
            }
            const localVarPath = `/createZip`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DownloadFilesAsZipRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(DownloadFilesAsZipRequest || {}) : (DownloadFilesAsZipRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a file based on path and filename.
         * @summary Delete file
         * @param {string} path path
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(path: string, companyId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'path' is not null or undefined
            if (path === null || path === undefined) {
                throw new RequiredError('path','Required parameter path was null or undefined when calling deleteFile.');
            }
            const localVarPath = `/files`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get the amount of files that are in /LOGS/CONVERTING for more than 5 minutes
         * @summary get the amount of files that are in /LOGS/CONVERTING for more than 5 minutes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvertingFilesCount(options: any = {}): FetchArgs {
            const localVarPath = `/monitoring/convertingFilesCount`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * responds a report of the disabled monitoring checks of all companies.
         * @summary get a report of the disabled monitoring checks of all companies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDisabledChecksReport(options: any = {}): FetchArgs {
            const localVarPath = `/monitoring/disabledChecksReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get the amount of files that are in /LOGS/ERROR for more than 5 minutes
         * @summary get the amount of files that are in /LOGS/ERROR for more than 5 minutes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorFilesCount(options: any = {}): FetchArgs {
            const localVarPath = `/monitoring/errorFilesCount`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finds if a company has files in the ROOT/companyId/logenios2customer directory that are older than 5 minutes.
         * @summary get files from the ROOT/logenios2customer directories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogenios2CustomerForAllCompanies(options: any = {}): FetchArgs {
            const localVarPath = `/monitoring/logenios2customer/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get the amount of files that are in /LOGS/NEEDSVERIFICATION for more than 5 minutes
         * @summary get the amount of files that are in /LOGS/NEEDSVERIFICATION for more than 5 minutes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNeedsVerificationFilesCount(options: any = {}): FetchArgs {
            const localVarPath = `/monitoring/needsVerificationFilesCount`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finds if a company has files in the LOGS/companyId/ERRORS directory that are older than 10 minutes in centralized way.
         * @summary get old files from the LOGS/ERRORS directories centralized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOldErrorFilesForAllCompanies(options: any = {}): FetchArgs {
            const localVarPath = `/monitoring/errorfiles/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * responds a report of the status json files across all companies, that should have them.
         * @summary get a report of the statusJson-files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusJsonReport(options: any = {}): FetchArgs {
            const localVarPath = `/monitoring/statusJsonReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all files inside the given path. Directories will be listed as files.
         * @summary list files of directory
         * @param {string} [companyId] companyId
         * @param {Date} [fromTime] fromTime
         * @param {number} [page] page
         * @param {string} [path] path
         * @param {string} [query] query
         * @param {boolean} [queryContent] queryContent
         * @param {'DIRECTORY' | 'NAME' | 'SIZE' | 'CREATED' | 'MODIFIED'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {Date} [toTime] toTime
         * @param {boolean} [useModifiedTime] useModifiedTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFiles(companyId?: string, fromTime?: Date, page?: number, path?: string, query?: string, queryContent?: boolean, sortBy?: 'DIRECTORY' | 'NAME' | 'SIZE' | 'CREATED' | 'MODIFIED', sortDirection?: 'ASC' | 'DESC', take?: number, toTime?: Date, useModifiedTime?: boolean, options: any = {}): FetchArgs {
            const localVarPath = `/files`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (fromTime !== undefined) {
                localVarQueryParameter['fromTime'] = (fromTime as any).toISOString();
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (queryContent !== undefined) {
                localVarQueryParameter['queryContent'] = queryContent;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (toTime !== undefined) {
                localVarQueryParameter['toTime'] = (toTime as any).toISOString();
            }

            if (useModifiedTime !== undefined) {
                localVarQueryParameter['useModifiedTime'] = useModifiedTime;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move a file to another location.
         * @summary Move file
         * @param {string} path path
         * @param {MoveFileRequest} MoveFileRequest MoveFileRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveFile(path: string, MoveFileRequest: MoveFileRequest, companyId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'path' is not null or undefined
            if (path === null || path === undefined) {
                throw new RequiredError('path','Required parameter path was null or undefined when calling moveFile.');
            }
            // verify required parameter 'MoveFileRequest' is not null or undefined
            if (MoveFileRequest === null || MoveFileRequest === undefined) {
                throw new RequiredError('MoveFileRequest','Required parameter MoveFileRequest was null or undefined when calling moveFile.');
            }
            const localVarPath = `/files/move`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MoveFileRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(MoveFileRequest || {}) : (MoveFileRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * gives back the content of a text file
         * @summary opens a file
         * @param {string} path path
         * @param {OpenFileRequest} OpenFileRequest OpenFileRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openFile(path: string, OpenFileRequest: OpenFileRequest, companyId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'path' is not null or undefined
            if (path === null || path === undefined) {
                throw new RequiredError('path','Required parameter path was null or undefined when calling openFile.');
            }
            // verify required parameter 'OpenFileRequest' is not null or undefined
            if (OpenFileRequest === null || OpenFileRequest === undefined) {
                throw new RequiredError('OpenFileRequest','Required parameter OpenFileRequest was null or undefined when calling openFile.');
            }
            const localVarPath = `/openFile`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OpenFileRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(OpenFileRequest || {}) : (OpenFileRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * gives back the content of a file
         * @summary opens a file
         * @param {string} file file
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openFileFromRoot(file: string, companyId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling openFileFromRoot.');
            }
            const localVarPath = `/files/{file}`
                .replace(`{${"file"}}`, encodeURIComponent(String(file)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * gives back the content of a file
         * @summary Downloads a file authorized by the given signed content.
         * @param {string} signedUrl signedUrl
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openFileFromRoot_1(signedUrl: string, companyId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'signedUrl' is not null or undefined
            if (signedUrl === null || signedUrl === undefined) {
                throw new RequiredError('signedUrl','Required parameter signedUrl was null or undefined when calling openFileFromRoot_1.');
            }
            const localVarPath = `/files/download/{signedUrl}`
                .replace(`{${"signedUrl"}}`, encodeURIComponent(String(signedUrl)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add text as file to a given location.
         * @summary Rename file
         * @param {string} path path
         * @param {RenameFileRequest} RenameFileRequest RenameFileRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFile(path: string, RenameFileRequest: RenameFileRequest, companyId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'path' is not null or undefined
            if (path === null || path === undefined) {
                throw new RequiredError('path','Required parameter path was null or undefined when calling renameFile.');
            }
            // verify required parameter 'RenameFileRequest' is not null or undefined
            if (RenameFileRequest === null || RenameFileRequest === undefined) {
                throw new RequiredError('RenameFileRequest','Required parameter RenameFileRequest was null or undefined when calling renameFile.');
            }
            const localVarPath = `/files/rename`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RenameFileRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(RenameFileRequest || {}) : (RenameFileRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload file to a given location.
         * @summary Upload file
         * @param {string} path path
         * @param {any} file file to upload
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(path: string, file: any, companyId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'path' is not null or undefined
            if (path === null || path === undefined) {
                throw new RequiredError('path','Required parameter path was null or undefined when calling uploadFile.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling uploadFile.');
            }
            const localVarPath = `/files/upload`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (file !== undefined) {
                localVarFormParams.set('file', file as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FTPApi - functional programming interface
 * @export
 */
export const FTPApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Add text as file to a given location.
         * @summary Add file
         * @param {string} path path
         * @param {AddFileRequest} AddFileRequest AddFileRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFile(path: string, AddFileRequest: AddFileRequest, companyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UploadFileResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).addFile(path, AddFileRequest, companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Add text as file to a given location.
         * @summary Add files
         * @param {string} path path
         * @param {AddFilesRequest} AddFilesRequest AddFilesRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFiles(path: string, AddFilesRequest: AddFilesRequest, companyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AddFilesResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).addFiles(path, AddFilesRequest, companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * gives back the content of a file
         * @summary opens a file
         * @param {string} file file
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateFileHashFromRoot(file: string, companyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FileHashResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).calculateFileHashFromRoot(file, companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Move a file to another location.
         * @summary create directory
         * @param {string} path path
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDirectory(path: string, companyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MoveFileResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).createDirectory(path, companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * creates a one time signature to download a file
         * @summary creates a one time signature to download a file
         * @param {string} fileName fileName
         * @param {string} filePath filePath
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDownloadSignature(fileName: string, filePath: string, companyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CreateDownloadSignatureResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).createDownloadSignature(fileName, filePath, companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * packs files as zip
         * @summary packs files as zip
         * @param {string} path path
         * @param {DownloadFilesAsZipRequest} DownloadFilesAsZipRequest DownloadFilesAsZipRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createZip(path: string, DownloadFilesAsZipRequest: DownloadFilesAsZipRequest, companyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CreateZipResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).createZip(path, DownloadFilesAsZipRequest, companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Delete a file based on path and filename.
         * @summary Delete file
         * @param {string} path path
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(path: string, companyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DeleteFileResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).deleteFile(path, companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * get the amount of files that are in /LOGS/CONVERTING for more than 5 minutes
         * @summary get the amount of files that are in /LOGS/CONVERTING for more than 5 minutes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvertingFilesCount(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetConvertingFilesCount> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).getConvertingFilesCount(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * responds a report of the disabled monitoring checks of all companies.
         * @summary get a report of the disabled monitoring checks of all companies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDisabledChecksReport(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DisabledChecksForCompanyReport> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).getDisabledChecksReport(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * get the amount of files that are in /LOGS/ERROR for more than 5 minutes
         * @summary get the amount of files that are in /LOGS/ERROR for more than 5 minutes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorFilesCount(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetErrorFilesCountResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).getErrorFilesCount(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Finds if a company has files in the ROOT/companyId/logenios2customer directory that are older than 5 minutes.
         * @summary get files from the ROOT/logenios2customer directories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogenios2CustomerForAllCompanies(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MonitoredFileOldResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).getLogenios2CustomerForAllCompanies(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * get the amount of files that are in /LOGS/NEEDSVERIFICATION for more than 5 minutes
         * @summary get the amount of files that are in /LOGS/NEEDSVERIFICATION for more than 5 minutes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNeedsVerificationFilesCount(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetNeedsVerificationFilesCountResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).getNeedsVerificationFilesCount(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Finds if a company has files in the LOGS/companyId/ERRORS directory that are older than 10 minutes in centralized way.
         * @summary get old files from the LOGS/ERRORS directories centralized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOldErrorFilesForAllCompanies(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MonitoredFileOldResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).getOldErrorFilesForAllCompanies(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * responds a report of the status json files across all companies, that should have them.
         * @summary get a report of the statusJson-files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusJsonReport(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<StatusJsonReport> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).getStatusJsonReport(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Lists all files inside the given path. Directories will be listed as files.
         * @summary list files of directory
         * @param {string} [companyId] companyId
         * @param {Date} [fromTime] fromTime
         * @param {number} [page] page
         * @param {string} [path] path
         * @param {string} [query] query
         * @param {boolean} [queryContent] queryContent
         * @param {'DIRECTORY' | 'NAME' | 'SIZE' | 'CREATED' | 'MODIFIED'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {Date} [toTime] toTime
         * @param {boolean} [useModifiedTime] useModifiedTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFiles(companyId?: string, fromTime?: Date, page?: number, path?: string, query?: string, queryContent?: boolean, sortBy?: 'DIRECTORY' | 'NAME' | 'SIZE' | 'CREATED' | 'MODIFIED', sortDirection?: 'ASC' | 'DESC', take?: number, toTime?: Date, useModifiedTime?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListFilesResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).listFiles(companyId, fromTime, page, path, query, queryContent, sortBy, sortDirection, take, toTime, useModifiedTime, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Move a file to another location.
         * @summary Move file
         * @param {string} path path
         * @param {MoveFileRequest} MoveFileRequest MoveFileRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveFile(path: string, MoveFileRequest: MoveFileRequest, companyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MoveFileResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).moveFile(path, MoveFileRequest, companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * gives back the content of a text file
         * @summary opens a file
         * @param {string} path path
         * @param {OpenFileRequest} OpenFileRequest OpenFileRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openFile(path: string, OpenFileRequest: OpenFileRequest, companyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).openFile(path, OpenFileRequest, companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * gives back the content of a file
         * @summary opens a file
         * @param {string} file file
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openFileFromRoot(file: string, companyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).openFileFromRoot(file, companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * gives back the content of a file
         * @summary Downloads a file authorized by the given signed content.
         * @param {string} signedUrl signedUrl
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openFileFromRoot_1(signedUrl: string, companyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).openFileFromRoot_1(signedUrl, companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Add text as file to a given location.
         * @summary Rename file
         * @param {string} path path
         * @param {RenameFileRequest} RenameFileRequest RenameFileRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFile(path: string, RenameFileRequest: RenameFileRequest, companyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RenameFileResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).renameFile(path, RenameFileRequest, companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Upload file to a given location.
         * @summary Upload file
         * @param {string} path path
         * @param {any} file file to upload
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(path: string, file: any, companyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UploadFileResponse> {
            const localVarFetchArgs = FTPApiFetchParamCreator(configuration).uploadFile(path, file, companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * FTPApi - factory interface
 * @export
 */
export const FTPApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Add text as file to a given location.
         * @summary Add file
         * @param {string} path path
         * @param {AddFileRequest} AddFileRequest AddFileRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFile(path: string, AddFileRequest: AddFileRequest, companyId?: string, options?: any) {
            return FTPApiFp(configuration).addFile(path, AddFileRequest, companyId, options)(fetch, basePath);
        },
        /**
         * Add text as file to a given location.
         * @summary Add files
         * @param {string} path path
         * @param {AddFilesRequest} AddFilesRequest AddFilesRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFiles(path: string, AddFilesRequest: AddFilesRequest, companyId?: string, options?: any) {
            return FTPApiFp(configuration).addFiles(path, AddFilesRequest, companyId, options)(fetch, basePath);
        },
        /**
         * gives back the content of a file
         * @summary opens a file
         * @param {string} file file
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateFileHashFromRoot(file: string, companyId?: string, options?: any) {
            return FTPApiFp(configuration).calculateFileHashFromRoot(file, companyId, options)(fetch, basePath);
        },
        /**
         * Move a file to another location.
         * @summary create directory
         * @param {string} path path
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDirectory(path: string, companyId?: string, options?: any) {
            return FTPApiFp(configuration).createDirectory(path, companyId, options)(fetch, basePath);
        },
        /**
         * creates a one time signature to download a file
         * @summary creates a one time signature to download a file
         * @param {string} fileName fileName
         * @param {string} filePath filePath
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDownloadSignature(fileName: string, filePath: string, companyId?: string, options?: any) {
            return FTPApiFp(configuration).createDownloadSignature(fileName, filePath, companyId, options)(fetch, basePath);
        },
        /**
         * packs files as zip
         * @summary packs files as zip
         * @param {string} path path
         * @param {DownloadFilesAsZipRequest} DownloadFilesAsZipRequest DownloadFilesAsZipRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createZip(path: string, DownloadFilesAsZipRequest: DownloadFilesAsZipRequest, companyId?: string, options?: any) {
            return FTPApiFp(configuration).createZip(path, DownloadFilesAsZipRequest, companyId, options)(fetch, basePath);
        },
        /**
         * Delete a file based on path and filename.
         * @summary Delete file
         * @param {string} path path
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(path: string, companyId?: string, options?: any) {
            return FTPApiFp(configuration).deleteFile(path, companyId, options)(fetch, basePath);
        },
        /**
         * get the amount of files that are in /LOGS/CONVERTING for more than 5 minutes
         * @summary get the amount of files that are in /LOGS/CONVERTING for more than 5 minutes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvertingFilesCount(options?: any) {
            return FTPApiFp(configuration).getConvertingFilesCount(options)(fetch, basePath);
        },
        /**
         * responds a report of the disabled monitoring checks of all companies.
         * @summary get a report of the disabled monitoring checks of all companies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDisabledChecksReport(options?: any) {
            return FTPApiFp(configuration).getDisabledChecksReport(options)(fetch, basePath);
        },
        /**
         * get the amount of files that are in /LOGS/ERROR for more than 5 minutes
         * @summary get the amount of files that are in /LOGS/ERROR for more than 5 minutes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorFilesCount(options?: any) {
            return FTPApiFp(configuration).getErrorFilesCount(options)(fetch, basePath);
        },
        /**
         * Finds if a company has files in the ROOT/companyId/logenios2customer directory that are older than 5 minutes.
         * @summary get files from the ROOT/logenios2customer directories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogenios2CustomerForAllCompanies(options?: any) {
            return FTPApiFp(configuration).getLogenios2CustomerForAllCompanies(options)(fetch, basePath);
        },
        /**
         * get the amount of files that are in /LOGS/NEEDSVERIFICATION for more than 5 minutes
         * @summary get the amount of files that are in /LOGS/NEEDSVERIFICATION for more than 5 minutes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNeedsVerificationFilesCount(options?: any) {
            return FTPApiFp(configuration).getNeedsVerificationFilesCount(options)(fetch, basePath);
        },
        /**
         * Finds if a company has files in the LOGS/companyId/ERRORS directory that are older than 10 minutes in centralized way.
         * @summary get old files from the LOGS/ERRORS directories centralized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOldErrorFilesForAllCompanies(options?: any) {
            return FTPApiFp(configuration).getOldErrorFilesForAllCompanies(options)(fetch, basePath);
        },
        /**
         * responds a report of the status json files across all companies, that should have them.
         * @summary get a report of the statusJson-files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusJsonReport(options?: any) {
            return FTPApiFp(configuration).getStatusJsonReport(options)(fetch, basePath);
        },
        /**
         * Lists all files inside the given path. Directories will be listed as files.
         * @summary list files of directory
         * @param {string} [companyId] companyId
         * @param {Date} [fromTime] fromTime
         * @param {number} [page] page
         * @param {string} [path] path
         * @param {string} [query] query
         * @param {boolean} [queryContent] queryContent
         * @param {'DIRECTORY' | 'NAME' | 'SIZE' | 'CREATED' | 'MODIFIED'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {Date} [toTime] toTime
         * @param {boolean} [useModifiedTime] useModifiedTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFiles(companyId?: string, fromTime?: Date, page?: number, path?: string, query?: string, queryContent?: boolean, sortBy?: 'DIRECTORY' | 'NAME' | 'SIZE' | 'CREATED' | 'MODIFIED', sortDirection?: 'ASC' | 'DESC', take?: number, toTime?: Date, useModifiedTime?: boolean, options?: any) {
            return FTPApiFp(configuration).listFiles(companyId, fromTime, page, path, query, queryContent, sortBy, sortDirection, take, toTime, useModifiedTime, options)(fetch, basePath);
        },
        /**
         * Move a file to another location.
         * @summary Move file
         * @param {string} path path
         * @param {MoveFileRequest} MoveFileRequest MoveFileRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveFile(path: string, MoveFileRequest: MoveFileRequest, companyId?: string, options?: any) {
            return FTPApiFp(configuration).moveFile(path, MoveFileRequest, companyId, options)(fetch, basePath);
        },
        /**
         * gives back the content of a text file
         * @summary opens a file
         * @param {string} path path
         * @param {OpenFileRequest} OpenFileRequest OpenFileRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openFile(path: string, OpenFileRequest: OpenFileRequest, companyId?: string, options?: any) {
            return FTPApiFp(configuration).openFile(path, OpenFileRequest, companyId, options)(fetch, basePath);
        },
        /**
         * gives back the content of a file
         * @summary opens a file
         * @param {string} file file
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openFileFromRoot(file: string, companyId?: string, options?: any) {
            return FTPApiFp(configuration).openFileFromRoot(file, companyId, options)(fetch, basePath);
        },
        /**
         * gives back the content of a file
         * @summary Downloads a file authorized by the given signed content.
         * @param {string} signedUrl signedUrl
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openFileFromRoot_1(signedUrl: string, companyId?: string, options?: any) {
            return FTPApiFp(configuration).openFileFromRoot_1(signedUrl, companyId, options)(fetch, basePath);
        },
        /**
         * Add text as file to a given location.
         * @summary Rename file
         * @param {string} path path
         * @param {RenameFileRequest} RenameFileRequest RenameFileRequest
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFile(path: string, RenameFileRequest: RenameFileRequest, companyId?: string, options?: any) {
            return FTPApiFp(configuration).renameFile(path, RenameFileRequest, companyId, options)(fetch, basePath);
        },
        /**
         * Upload file to a given location.
         * @summary Upload file
         * @param {string} path path
         * @param {any} file file to upload
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(path: string, file: any, companyId?: string, options?: any) {
            return FTPApiFp(configuration).uploadFile(path, file, companyId, options)(fetch, basePath);
        },
    };
};

/**
 * FTPApi - object-oriented interface
 * @export
 * @class FTPApi
 * @extends {BaseAPI}
 */
export class FTPApi extends BaseAPI {
    /**
     * Add text as file to a given location.
     * @summary Add file
     * @param {string} path path
     * @param {AddFileRequest} AddFileRequest AddFileRequest
     * @param {string} [companyId] companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public addFile(path: string, AddFileRequest: AddFileRequest, companyId?: string, options?: any) {
        return FTPApiFp(this.configuration).addFile(path, AddFileRequest, companyId, options)(this.fetch, this.basePath);
    }

    /**
     * Add text as file to a given location.
     * @summary Add files
     * @param {string} path path
     * @param {AddFilesRequest} AddFilesRequest AddFilesRequest
     * @param {string} [companyId] companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public addFiles(path: string, AddFilesRequest: AddFilesRequest, companyId?: string, options?: any) {
        return FTPApiFp(this.configuration).addFiles(path, AddFilesRequest, companyId, options)(this.fetch, this.basePath);
    }

    /**
     * gives back the content of a file
     * @summary opens a file
     * @param {string} file file
     * @param {string} [companyId] companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public calculateFileHashFromRoot(file: string, companyId?: string, options?: any) {
        return FTPApiFp(this.configuration).calculateFileHashFromRoot(file, companyId, options)(this.fetch, this.basePath);
    }

    /**
     * Move a file to another location.
     * @summary create directory
     * @param {string} path path
     * @param {string} [companyId] companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public createDirectory(path: string, companyId?: string, options?: any) {
        return FTPApiFp(this.configuration).createDirectory(path, companyId, options)(this.fetch, this.basePath);
    }

    /**
     * creates a one time signature to download a file
     * @summary creates a one time signature to download a file
     * @param {string} fileName fileName
     * @param {string} filePath filePath
     * @param {string} [companyId] companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public createDownloadSignature(fileName: string, filePath: string, companyId?: string, options?: any) {
        return FTPApiFp(this.configuration).createDownloadSignature(fileName, filePath, companyId, options)(this.fetch, this.basePath);
    }

    /**
     * packs files as zip
     * @summary packs files as zip
     * @param {string} path path
     * @param {DownloadFilesAsZipRequest} DownloadFilesAsZipRequest DownloadFilesAsZipRequest
     * @param {string} [companyId] companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public createZip(path: string, DownloadFilesAsZipRequest: DownloadFilesAsZipRequest, companyId?: string, options?: any) {
        return FTPApiFp(this.configuration).createZip(path, DownloadFilesAsZipRequest, companyId, options)(this.fetch, this.basePath);
    }

    /**
     * Delete a file based on path and filename.
     * @summary Delete file
     * @param {string} path path
     * @param {string} [companyId] companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public deleteFile(path: string, companyId?: string, options?: any) {
        return FTPApiFp(this.configuration).deleteFile(path, companyId, options)(this.fetch, this.basePath);
    }

    /**
     * get the amount of files that are in /LOGS/CONVERTING for more than 5 minutes
     * @summary get the amount of files that are in /LOGS/CONVERTING for more than 5 minutes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public getConvertingFilesCount(options?: any) {
        return FTPApiFp(this.configuration).getConvertingFilesCount(options)(this.fetch, this.basePath);
    }

    /**
     * responds a report of the disabled monitoring checks of all companies.
     * @summary get a report of the disabled monitoring checks of all companies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public getDisabledChecksReport(options?: any) {
        return FTPApiFp(this.configuration).getDisabledChecksReport(options)(this.fetch, this.basePath);
    }

    /**
     * get the amount of files that are in /LOGS/ERROR for more than 5 minutes
     * @summary get the amount of files that are in /LOGS/ERROR for more than 5 minutes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public getErrorFilesCount(options?: any) {
        return FTPApiFp(this.configuration).getErrorFilesCount(options)(this.fetch, this.basePath);
    }

    /**
     * Finds if a company has files in the ROOT/companyId/logenios2customer directory that are older than 5 minutes.
     * @summary get files from the ROOT/logenios2customer directories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public getLogenios2CustomerForAllCompanies(options?: any) {
        return FTPApiFp(this.configuration).getLogenios2CustomerForAllCompanies(options)(this.fetch, this.basePath);
    }

    /**
     * get the amount of files that are in /LOGS/NEEDSVERIFICATION for more than 5 minutes
     * @summary get the amount of files that are in /LOGS/NEEDSVERIFICATION for more than 5 minutes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public getNeedsVerificationFilesCount(options?: any) {
        return FTPApiFp(this.configuration).getNeedsVerificationFilesCount(options)(this.fetch, this.basePath);
    }

    /**
     * Finds if a company has files in the LOGS/companyId/ERRORS directory that are older than 10 minutes in centralized way.
     * @summary get old files from the LOGS/ERRORS directories centralized
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public getOldErrorFilesForAllCompanies(options?: any) {
        return FTPApiFp(this.configuration).getOldErrorFilesForAllCompanies(options)(this.fetch, this.basePath);
    }

    /**
     * responds a report of the status json files across all companies, that should have them.
     * @summary get a report of the statusJson-files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public getStatusJsonReport(options?: any) {
        return FTPApiFp(this.configuration).getStatusJsonReport(options)(this.fetch, this.basePath);
    }

    /**
     * Lists all files inside the given path. Directories will be listed as files.
     * @summary list files of directory
     * @param {string} [companyId] companyId
     * @param {Date} [fromTime] fromTime
     * @param {number} [page] page
     * @param {string} [path] path
     * @param {string} [query] query
     * @param {boolean} [queryContent] queryContent
     * @param {'DIRECTORY' | 'NAME' | 'SIZE' | 'CREATED' | 'MODIFIED'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {number} [take] take
     * @param {Date} [toTime] toTime
     * @param {boolean} [useModifiedTime] useModifiedTime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public listFiles(companyId?: string, fromTime?: Date, page?: number, path?: string, query?: string, queryContent?: boolean, sortBy?: 'DIRECTORY' | 'NAME' | 'SIZE' | 'CREATED' | 'MODIFIED', sortDirection?: 'ASC' | 'DESC', take?: number, toTime?: Date, useModifiedTime?: boolean, options?: any) {
        return FTPApiFp(this.configuration).listFiles(companyId, fromTime, page, path, query, queryContent, sortBy, sortDirection, take, toTime, useModifiedTime, options)(this.fetch, this.basePath);
    }

    /**
     * Move a file to another location.
     * @summary Move file
     * @param {string} path path
     * @param {MoveFileRequest} MoveFileRequest MoveFileRequest
     * @param {string} [companyId] companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public moveFile(path: string, MoveFileRequest: MoveFileRequest, companyId?: string, options?: any) {
        return FTPApiFp(this.configuration).moveFile(path, MoveFileRequest, companyId, options)(this.fetch, this.basePath);
    }

    /**
     * gives back the content of a text file
     * @summary opens a file
     * @param {string} path path
     * @param {OpenFileRequest} OpenFileRequest OpenFileRequest
     * @param {string} [companyId] companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public openFile(path: string, OpenFileRequest: OpenFileRequest, companyId?: string, options?: any) {
        return FTPApiFp(this.configuration).openFile(path, OpenFileRequest, companyId, options)(this.fetch, this.basePath);
    }

    /**
     * gives back the content of a file
     * @summary opens a file
     * @param {string} file file
     * @param {string} [companyId] companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public openFileFromRoot(file: string, companyId?: string, options?: any) {
        return FTPApiFp(this.configuration).openFileFromRoot(file, companyId, options)(this.fetch, this.basePath);
    }

    /**
     * gives back the content of a file
     * @summary Downloads a file authorized by the given signed content.
     * @param {string} signedUrl signedUrl
     * @param {string} [companyId] companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public openFileFromRoot_1(signedUrl: string, companyId?: string, options?: any) {
        return FTPApiFp(this.configuration).openFileFromRoot_1(signedUrl, companyId, options)(this.fetch, this.basePath);
    }

    /**
     * Add text as file to a given location.
     * @summary Rename file
     * @param {string} path path
     * @param {RenameFileRequest} RenameFileRequest RenameFileRequest
     * @param {string} [companyId] companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public renameFile(path: string, RenameFileRequest: RenameFileRequest, companyId?: string, options?: any) {
        return FTPApiFp(this.configuration).renameFile(path, RenameFileRequest, companyId, options)(this.fetch, this.basePath);
    }

    /**
     * Upload file to a given location.
     * @summary Upload file
     * @param {string} path path
     * @param {any} file file to upload
     * @param {string} [companyId] companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public uploadFile(path: string, file: any, companyId?: string, options?: any) {
        return FTPApiFp(this.configuration).uploadFile(path, file, companyId, options)(this.fetch, this.basePath);
    }

}

